<div class="modal-header">
    <h4 class="modal-title">Add Attendance</h4>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="modalForm">
      <div class="form-group">
        <label for="field1">Feedback<span class="required_field">*</span></label>
        <textarea id="field1" class="form-control" formControlName="stu_feedback" name="field1"></textarea>
      </div>
      <div class="form-group">
        <label for="field2">Personal Feedback</label>
        <textarea id="field2" class="form-control" formControlName="private_feedback" name="field2"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" (click)="submit()" class="btn btn-primary" [disabled]="!modalForm.valid">Submit</button>
  </div>
  